var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInkedinWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.519 5.417a2.167 2.167 0 11-4.333-.002 2.167 2.167 0 014.333.002zm.065 3.77H3.25V22.75h4.333V9.187zm6.847 0h-4.312V22.75h4.268v-7.117c0-3.965 5.168-4.334 5.168 0v7.117h4.279v-8.59c0-6.685-7.648-6.436-9.447-3.153l.043-1.82z",
    fill: "#fff"
  })));
}

export default SvgInkedinWhiteIcon;